package com.starparty.app.astro0

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class Location(time: SP_Time, lat: Double, lon: Double) {
    var place: SP_Place
    var time: SP_Time

    /** Returns local siderial time in degrees.
     * The approximation is within 0.3 seconds of time
     * for dates within 100 years of J2000.  */
    val localSiderealTime: Double
        get() {
            val lon = place.longitude
            var lst = time.siderealTime + lon
            lst += 360.0
            lst += 360.0

            val hlst: Double = UMS.unitMinSecToDecimal(UMS.degreesToHMS(lst))
            return lst
            //return UMS.unitMinSecToDecimal(7, 12, 17.4) * 15;
        }

    init {
        place = SP_Place(lat, lon)
        this.time = time
    }
}